import { Typography, useMediaQuery, useTheme } from '@mui/material';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { PLAN_TYPE_NAME } from '@hapvida/hapvida-core-components';

import { useAuth } from '@hooks';
import { PartnerCompanyTypeChip } from '@components';
import { PartnerCompanyListRouter } from '@flows/private/partnerCompanies/pages/PartnerCompanyList/router';
import { PLAN_TYPE_COLOR } from '@flows/private/partnerCompanies/pages/PartnerCompanyList/constants/contractTypeEnum';
import { PartnerCompanyStatusChip } from '@flows/private/partnerCompanies/pages/PartnerCompanyList/components/PartnerCompaniesStatusChip';

import { HeaderItem } from '../HeaderItem';
import { SelectedPartnerCompanyMobile } from './components/SelectedPartnerCompanyMobile';

export function SelectedPartnerCompany() {
  const { selectedPartnerCompany } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const onClick = useCallback(() => {
    navigate(PartnerCompanyListRouter.path);
  }, [navigate]);

  if (!selectedPartnerCompany) {
    return null;
  }

  const {
    partnerCompany,
    isMainPartnerCompany,
    legal,
    planType,
    complement,
    partnerCompanyStatus,
  } = selectedPartnerCompany;

  return (
    <>
      {isMobile ? (
        <SelectedPartnerCompanyMobile
          partnerCompany={partnerCompany}
          isMainPartnerCompany={isMainPartnerCompany}
          onClick={onClick}
          planType={planType}
        />
      ) : (
        <HeaderItem onClickEdit={onClick}>
          <Typography variant="text" fontWeight={900}>
            {partnerCompany}
          </Typography>
          <PartnerCompanyTypeChip isMainPartnerCompany={isMainPartnerCompany} />
          <Typography variant="text" fontWeight={900}>
            —
          </Typography>
          <Typography variant="text">{legal}</Typography>
          {complement && (
            <>
              <Typography variant="text" fontWeight={900}>
                —
              </Typography>
              <Typography variant="text">{complement}</Typography>
            </>
          )}
          <Typography variant="text" fontWeight={900}>
            —
          </Typography>
          {planType && (
            <>
              <Typography
                fontWeight={700}
                color={PLAN_TYPE_COLOR[planType]}
                variant="text"
              >
                {PLAN_TYPE_NAME[planType]}
              </Typography>
              <Typography variant="text" fontWeight={900}>
                —
              </Typography>
            </>
          )}
          <PartnerCompanyStatusChip
            fontSize="12px"
            status={partnerCompanyStatus}
            size="small"
          />
        </HeaderItem>
      )}
    </>
  );
}
